import { Component, input } from '@angular/core';

import { CamTranslationCore } from '@camelot/core';
import { TranslatePipe } from '@camelot/translation';
import { BadgeComponent } from '@camelot/ui';
import { CamBaseComponent } from '@camelot/utils';

import { Unit } from '../../services/dto/unit';

export const unitLabel = (unit: Unit) => `core.default-unit.${Unit[unit]?.toLowerCase() ?? 'unknown'}`;

@Component({
  imports: [BadgeComponent, TranslatePipe],
  selector: 'cam-unit-status',
  styleUrl: './unit-status.component.scss',
  templateUrl: './unit-status.component.html',
})
export class UnitStatusComponent extends CamBaseComponent {
  unit = input.required<Unit>();

  constructor() {
    super();
    CamTranslationCore.getInstance();
  }

  public getTranslate() {
    return unitLabel(this.unit());
  }
}
